import React, { useState, useEffect, useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { AuthContext } from '@/contexts/AuthContext'
import { collectionToArray } from '@/utils/collectionToArray'
import { convertAmount } from '@/utils/currencyResolver'
import { getOrdinal } from '@/utils/getOrdinal'
import { useFirestore } from 'react-redux-firebase'
import Link from '@/components/Link'
import { ShieldCheckIcon } from '@heroicons/react/solid'
import { classNames } from '@/utils/classNames'
import Loader from '../../components/Loader'
import Tabs from '../../components/Tabs'
import { RadioGroup } from '@headlessui/react'

export default function Leaderboard() {
  const { stats } = useContext(AuthContext)
  const [statsData, setStatsData] = useState([])
  const [statsLoaded, setStatsLoaded] = useState(false)
  const [filter, setFilter] = useState("all")

  const filters = {
    wagers: {
      all: 'wagerAll',
      daily: 'wagerDaily',
      weekly: 'wagerWeekly',
      monthly: 'wagerMonthly'
    },
    profits: {
      all: 'profitAll',
      daily: 'profitDaily',
      weekly: 'profitWeekly',
      monthly: 'profitMonthly'
    },
    winStreak: {
      all: 'streakHighestAll',
      daily: 'streakHighestDaily',
      weekly: 'streakHighestWeekly',
      monthly: 'streakHighestMonthly'
    },
    lossStreak: {
      all: 'streakLowestAll',
      daily: 'streakLowestDaily',
      weekly: 'streakLowestWeekly',
      monthly: 'streakLowestMonthly'
    },
  }

  useEffect(() => {
    // console.log(stats)
    setStatsData(collectionToArray(stats))
    setStatsLoaded(true)
  }, [stats])
  return (
    <>
      <Helmet>
        <title>Staking Leaderboards</title>
      </Helmet>
      <div className="py-8">
        <div className="mb-4 sm:flex justify-between items-end">
          <div className="md:flex items-center container">
            <h1 className="font-medium text-lg sm:text-xl text-white mr-4">Leaderboards</h1>
            {/* <div className="flex space-x-4 w-full mt-2 sm:mt-0 sm:w-auto items-center">
              <div className="flex-1">
                <RadioGroup className="flex flex-wrap space-x-2" value={filter} onChange={setFilter}>
                  <RadioGroup.Option value={"all"}>
                    {({ checked }) => (
                      <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>All Time</span>
                    )}
                  </RadioGroup.Option>
                  <RadioGroup.Option value={"daily"}>
                    {({ checked }) => (
                      <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Daily</span>
                    )}
                  </RadioGroup.Option>
                  <RadioGroup.Option value={"weekly"}>
                    {({ checked }) => (
                      <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Weekly</span>
                    )}
                  </RadioGroup.Option>
                  <RadioGroup.Option value={"monthly"}>
                    {({ checked }) => (
                      <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Monthly</span>
                    )}
                  </RadioGroup.Option>
                </RadioGroup>
              </div>
            </div> */}
          </div>
        </div>
        <Tabs
          items={[
            {
              title: 'Wager',
              panel: <div className="container mt-8">
                <div className="rounded-md overflow-hidden">
                  <div className="bg-gray-900 rounded-t-md">
                    <div className="flex w-full mt-2 sm:mt-0 sm:w-auto items-center">
                      <div className="flex-1">
                        <RadioGroup className="flex flex-wrap space-x-2" value={filter} onChange={setFilter}>
                          <RadioGroup.Option value={"all"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>All Time</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"daily"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Daily</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"weekly"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Weekly</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"monthly"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Monthly</span>
                            )}
                          </RadioGroup.Option>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-gray-300 bg-gray-800">
                      <thead className="mb-4">
                        <tr className="bg-gray-700">
                          <th className="w-24 p-4 text-sm font-medium text-white text-left rounded-l">User</th>
                          <th className="w-24 p-4 text-sm font-medium text-white text-right rounded-r">Wagered</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statsData.sort((a, b) => a[filters['wagers'][filter]] > b[filters['wagers'][filter]] ? -1 : 1).slice(0, 8)?.map((item, index) => <WagerTableRow value={filters['wagers'][filter]} item={item} key={index} index={index} />)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            },
            {
              title: 'Profit',
              panel: <div className="container mt-8">
                <div className="rounded-md overflow-hidden">
                  <div className="bg-gray-900 rounded-t-md">
                    <div className="flex w-full mt-2 sm:mt-0 sm:w-auto items-center">
                      <div className="flex-1">
                        <RadioGroup className="flex flex-wrap space-x-2" value={filter} onChange={setFilter}>
                          <RadioGroup.Option value={"all"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>All Time</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"daily"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Daily</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"weekly"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Weekly</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"monthly"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Monthly</span>
                            )}
                          </RadioGroup.Option>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-gray-300 bg-gray-800">
                      <thead className="mb-4">
                        <tr className="bg-gray-700">
                          <th className="w-24 p-4 text-sm font-medium text-white text-left rounded-l">User</th>
                          <th className="w-24 p-4 text-sm font-medium text-white text-right rounded-r">Profit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statsData.sort((a, b) => a[filters['profits'][filter]] > b[filters['profits'][filter]] ? -1 : 1).slice(0, 8)?.map((item, index) => <ProfitTableRow value={filters['profits'][filter]} item={item} key={index} index={index} />)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            },
            {
              title: 'Win Streak',
              panel: <div className="container mt-8">
                <div className="rounded-md overflow-hidden">
                  <div className="bg-gray-900 rounded-t-md">
                    <div className="flex w-full mt-2 sm:mt-0 sm:w-auto items-center">
                      <div className="flex-1">
                        <RadioGroup className="flex flex-wrap space-x-2" value={filter} onChange={setFilter}>
                          <RadioGroup.Option value={"all"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>All Time</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"daily"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Daily</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"weekly"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Weekly</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"monthly"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Monthly</span>
                            )}
                          </RadioGroup.Option>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-gray-300 bg-gray-800">
                      <thead className="mb-4">
                        <tr className="bg-gray-700">
                          <th className="w-24 p-4 text-sm font-medium text-white text-left rounded-l">User</th>
                          <th className="w-24 p-4 text-sm font-medium text-white text-right rounded-r">Streak</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statsData.sort((a, b) => a[filters['winStreak'][filter]] > b[filters['winStreak'][filter]] ? -1 : 1).slice(0, 8)?.map((item, index) => <StreakTableRow value={filters['winStreak'][filter]} item={item} key={index} index={index} />)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            },
            {
              title: 'Loss Streak',
              panel: <div className="container mt-8">
                <div className="rounded-md overflow-hidden">
                  <div className="bg-gray-900 rounded-t-md">
                    <div className="flex w-full mt-2 sm:mt-0 sm:w-auto items-center">
                      <div className="flex-1">
                        <RadioGroup className="flex flex-wrap space-x-2" value={filter} onChange={setFilter}>
                          <RadioGroup.Option value={"all"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>All Time</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"daily"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Daily</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"weekly"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Weekly</span>
                            )}
                          </RadioGroup.Option>
                          <RadioGroup.Option value={"monthly"}>
                            {({ checked }) => (
                              <span className={classNames('py-4 px-6 whitespace-nowrap cursor-pointer relative transition duration-300 flex items-center justify-center font-medium border-b-2', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>Monthly</span>
                            )}
                          </RadioGroup.Option>
                        </RadioGroup>
                      </div>
                    </div>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-gray-300 bg-gray-800">
                      <thead className="mb-4">
                        <tr className="bg-gray-700">
                          <th className="w-24 p-4 text-sm font-medium text-white text-left rounded-l">User</th>
                          <th className="w-24 p-4 text-sm font-medium text-white text-right rounded-r">Streak</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statsData.sort((a, b) => a[filters['lossStreak'][filter]] < b[filters['lossStreak'][filter]] ? -1 : 1).slice(0, 8)?.map((item, index) => <StreakTableRow value={filters['lossStreak'][filter]} item={item} key={index} index={index} />)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            },
          ]}
          navWrapperClass="flex justify-start mb-4 container w-full"
          routing={false}
        />
        {/* <div className="overflow-x-auto">
          {statsLoaded ? (
            statsData.length > 0 ? (
              <table className="w-full text-gray-200">
                <thead className="mb-4">
                  <tr>
                    <th className="w-24 p-4 text-sm font-medium text-left">User</th>
                    <th className="w-24 p-4 text-sm font-medium text-right">Wagered</th>
                  </tr>
                </thead>
                <tbody>
                  {statsData
                    .sort((a, b) => a[selected] > b[selected] ? -1 : 1)
                    .slice(0, 10)
                    .map((item, index) => <TableRow item={item} key={item.id} value={selected} index={index} />
                    )}
                </tbody>
              </table>
            ) : (
              <p className="py-8 text-center text-gray-300">No leaderboard history available.</p>
            )
          ) : (
            <Loader />
          )}
        </div> */}
      </div>
    </>
  )
}

const WagerTableRow = ({ item, index, value }) => {
  const firestore = useFirestore()
  const [userData, setUserData] = useState(null)
  useEffect(() => {
    const setData = async () => {
      const userRef = await firestore.collection("users").doc(item.id).get()
      const userData = userRef.data()
      setUserData({
        id: item.id,
        privacy: { ...userData?.privacy },
        username: userData?.privacy?.stats ? 'Hidden' : userData?.username
      })
    }
    setData()
  }, [item])
  return (
    <tr className="p-4 rounded odd:bg-gray-900 rounded">
      <td className="p-4 text-sm rounded-l">
        <div className="flex items-center">
          <span className="text-gray-200 mr-1 ">{getOrdinal(index + 1)}.</span>
          <span>{userProfileLink(userData?.username)}</span>
        </div>
      </td>
      <td className="p-4 text-sm rounded-r">
        <div className="flex items-center justify-end">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(item[value])}
        </div>
      </td>
    </tr>
  )
}

const ProfitTableRow = ({ item, index, value }) => {
  const firestore = useFirestore()
  const [userData, setUserData] = useState(null)
  useEffect(() => {
    const setData = async () => {
      const userRef = await firestore.collection("users").doc(item.id).get()
      const userData = userRef.data()
      setUserData({
        id: item.id,
        privacy: { ...userData?.privacy },
        username: userData?.privacy?.stats ? 'Hidden' : userData?.username
      })
    }
    setData()
  }, [item])
  return (
    <tr className="p-4 rounded odd:bg-gray-900 rounded">
      <td className="p-4 text-sm rounded-l">
        <div className="flex items-center">
          <span className="text-gray-200 mr-1 ">{getOrdinal(index + 1)}.</span>
          <span>{userProfileLink(userData?.username)}</span>
        </div>
      </td>
      <td className="p-4 text-sm rounded-r">
        <div className="flex items-center justify-end">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(item[value])}
        </div>
      </td>
    </tr>
  )
}

const StreakTableRow = ({ item, index, value }) => {
  const firestore = useFirestore()
  const [userData, setUserData] = useState(null)
  useEffect(() => {
    const setData = async () => {
      const userRef = await firestore.collection("users").doc(item.id).get()
      const userData = userRef.data()
      setUserData({
        id: item.id,
        privacy: { ...userData?.privacy },
        username: userData?.privacy?.stats ? 'Hidden' : userData?.username
      })
    }
    setData()
  }, [item])
  return (
    <tr className="p-4 odd:bg-gray-900">
      <td className="p-4 text-sm rounded-l">
        <div className="flex items-center">
          <span className="text-gray-200 mr-1 ">{getOrdinal(index + 1)}.</span>
          <span>{userProfileLink(userData?.username)}</span>
        </div>
      </td>
      <td className="p-4 text-sm rounded-r">
        <div className="flex items-center justify-end">
          {item[value]}
        </div>
      </td>
    </tr>
  )
}

const TableRow = ({ item, index, value }) => {
  const firestore = useFirestore()
  const [userData, setUserData] = useState(null)
  useEffect(() => {
    const setData = async () => {
      const userRef = await firestore.collection("users").doc(item.id).get()
      const userData = userRef.data()
      setUserData({
        id: item.id,
        privacy: { ...userData?.privacy },
        username: userData?.privacy?.stats ? 'Hidden' : userData?.username
      })
    }
    setData()
  }, [item])
  return (
    <tr className="p-4 rounded odd:bg-gray-900 rounded">
      <td className="p-4 text-sm rounded-l">
        <div className="flex items-center">
          <span className="text-gray-200 mr-1 ">{getOrdinal(index + 1)}.</span>
          <span>{userProfileLink(userData?.username)}</span>
        </div>
      </td>
      <td className="p-4 text-sm">
        <div className="flex items-center justify-end">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(item[value])}
        </div>
      </td>
    </tr>
  )
}

const userProfileLink = (user) => {
  if (user == "Hidden") return (
    <p className="flex items-center justify-center space-x-1">
      <ShieldCheckIcon className="w-4" />
      <span className="font-medium">Hidden</span>
    </p>
  )
  return (
    <Link className="flex items-center justify-center space-x-1" to={{ search: '&modal=user&name=' + user }}>
      <span className="text-gray-200 font-medium">{user}</span>
    </Link>
  )
}